import { createRowsFromConfig, } from "@tedivo/tedivo-bay-grid-pure";
const name = "lidDataForBaysValidator";
const okTranslationKey = "validators:lids.lidDataForBaysValidator.ok";
const errorTranslationKey = "validators:lids.lidDataForBaysValidator.error";
const specialScopes = [];
/** Check if lids extend correctly over below bays */
export const lidDataForBaysValidator = {
    name,
    okTranslationKey,
    errorTranslationKey,
    fn: lidDataForBaysValidatorFn,
    specialScopes,
    severity: "error",
    stage: "semantic",
};
export function lidDataForBaysValidatorFn({ data: { json, lcgVcgTcgAndPairings }, }) {
    const { sizeSummary, lidData } = json;
    const blpsBelow = (lcgVcgTcgAndPairings === null || lcgVcgTcgAndPairings === void 0 ? void 0 : lcgVcgTcgAndPairings.bayLevelPositionsBelow) || [];
    const blockBaysAndSizesBy20Bay = (lcgVcgTcgAndPairings === null || lcgVcgTcgAndPairings === void 0 ? void 0 : lcgVcgTcgAndPairings.blockBaysAndSizesBy20Bay) || {};
    if (sizeSummary.maxRow === undefined)
        return {
            name,
            isValid: true,
            messageTranslationKey: okTranslationKey,
            result: {
                validResults: [],
                invalidResults: [],
                allLids: [],
                rowTcgsByBay: {},
            },
        };
    const maxRow = sizeSummary.maxRow;
    const rowTcgsByBay = copyTcgOfRowsByBay(blpsBelow, lcgVcgTcgAndPairings);
    const lidsDataWithValidation = lidData.map((lid) => {
        var _a, _b, _c, _d;
        let notValid = undefined;
        let containersWithTcg = 0;
        const bays = [
            ...(((_b = (_a = blockBaysAndSizesBy20Bay[lid.startIsoBay]) === null || _a === void 0 ? void 0 : _a.allBays) === null || _b === void 0 ? void 0 : _b.split("-")) || []),
            ...(((_d = (_c = blockBaysAndSizesBy20Bay[lid.endIsoBay]) === null || _c === void 0 ? void 0 : _c.allBays) === null || _d === void 0 ? void 0 : _d.split("-")) || []),
        ].filter((b, idx, arr) => arr.indexOf(b) === idx);
        // Row 00 is only expected if some bay-level below the lid has the centerline row
        // (vessel-wide flag, unless the bay-level opts out)
        const hasCenterLineRow = blpsBelow.some((blp) => bays.includes(blp.isoBay) && blp.hasCenterLineRowForTcgs);
        const rowsArraySorted = createRowsFromConfig(hasCenterLineRow, maxRow);
        const portIndex = rowsArraySorted.indexOf(lid.portIsoRow);
        const stbdIndex = rowsArraySorted.indexOf(lid.starboardIsoRow);
        for (let i = portIndex; i <= stbdIndex; i++) {
            const row = rowsArraySorted[i];
            // ?? (not ||): the TCG of row 00 is 0
            const tcg = bays.reduce((acc, bay) => {
                var _a;
                return acc !== null && acc !== void 0 ? acc : (_a = rowTcgsByBay === null || rowTcgsByBay === void 0 ? void 0 : rowTcgsByBay[bay]) === null || _a === void 0 ? void 0 : _a[row];
            }, undefined);
            if (tcg !== undefined) {
                containersWithTcg++;
            }
        }
        if (containersWithTcg === 0) {
            notValid = "danger";
        }
        else if (containersWithTcg < Math.abs(stbdIndex - portIndex) + 1) {
            notValid = "warning";
        }
        const res = Object.assign(Object.assign({}, lid), { notValid });
        return res;
    });
    const invalidResults = lidsDataWithValidation.filter((lid) => lid.notValid);
    const validResults = lidsDataWithValidation.filter((lid) => !lid.notValid);
    const isValid = invalidResults.length === 0;
    return {
        name,
        isValid,
        messageTranslationKey: isValid ? okTranslationKey : errorTranslationKey,
        result: {
            validResults,
            invalidResults,
            allLids: lidsDataWithValidation,
            rowTcgsByBay,
        },
    };
}
//  Helpers
function copyTcgOfRowsByBay(blps, lcgVcgTcgAndPairings) {
    const rowTcgsByBay = {};
    blps.forEach(copyTcgOfRows);
    function copyTcgOfRows(blp) {
        const perRowAverageBayTcg = blp.perRowAverageBayTcg;
        // Rows with non-restricted slots. perRowAverageBayTcg alone is not enough:
        // rows without a defined TCG (e.g. a vessel without CGs) are not in it.
        const rows = new Set(perRowAverageBayTcg.keys());
        blp.cellsInfo.forEach((cell) => {
            if (!cell.restricted)
                rows.add(cell.row);
        });
        rows.forEach((row) => {
            if (!rowTcgsByBay[blp.isoBay])
                rowTcgsByBay[blp.isoBay] = {};
            rowTcgsByBay[blp.isoBay][row] =
                perRowAverageBayTcg.get(row) ||
                    (lcgVcgTcgAndPairings === null || lcgVcgTcgAndPairings === void 0 ? void 0 : lcgVcgTcgAndPairings.getMissingTcg(row, blp.isoBay, blp.level)) ||
                    0;
        });
    }
    return rowTcgsByBay;
}
